<fgb-page-header [pageTitle]="'checkout.page.title'" [showBalance]="false" [showQr]="false"></fgb-page-header>

<div class="container">
  <div class="row">
    <div class="col-lg-7 col-12">
      <h4 class="page-title">{{ 'cart.itemsSummary' | translate }}</h4>
      <div class="item-container">
        <fgbcl-cart-item [isCheckoutPage]="true"></fgbcl-cart-item>
      </div>
      <button class="btn fw-bold ps-0 go-back-btn" (click)="goBack()">
        <span class="font-size-14 text-go-back">{{ 'cart.goBack' | translate }}</span>
      </button>
    </div>
    <div class="col-lg-5 col-12">
      <!--member details address-->
      <div class="address-container mt-0" [ngClass]="{ 'd-none': editingMemberAddress }">
        <div class="d-flex justify-content-between mb-2">
          <p class="font-size-14 mb-0 fw-bold">Billing address</p>
          <p class="cursor-pointer font-size-14 fw-bold mb-0" (click)="editMemberAddress()">
            {{ 'billing.address.edit' | translate }}
          </p>
        </div>
        <div class="col-10">
          <span *ngIf="memberDetail$ | async as member" class="font-size-14 mb-0 d-flex flex-wrap">
            <div>{{ member.Street }},&nbsp;</div>
            <div>{{ member.Town }},&nbsp;</div>
            <div>{{ member.County }},&nbsp;</div>
            <div>{{ member.Country }},&nbsp;</div>
            <div>{{ member.PostCode }},&nbsp;</div>
            <div>{{ member.HomeNumber }}</div>
          </span>
        </div>
      </div>
      <!--EO member details address view-->

      <!-- EDIT MEMBER DETAILS ADDRESS FORM -->
      <ng-container *ngIf="editingMemberAddress">
        <div class="container address-container mb-3">
          <div class="position-relative p-2">
            <div class="d-flex justify-content-between align-items-center">
              <p class="font-size-14 fw-bold mb-0 text-capitalize">{{ 'cart.billing.address' | translate }}</p>
              <a (click)="clearAddressForm(memberAddressForm)" class="font-size-14 cursor-pointer fw-bold text-error">{{
                'cart.clear.form' | translate
              }}</a>
            </div>

            <form [formGroup]="memberAddressForm" class="font-size-12 d-flex flex-column edit-container">
              <!--Street-->
              <div class="form-group form-floating">
                <input
                  id="Street"
                  class="form-control"
                  name="Street"
                  type="text"
                  formControlName="Street"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Street.errors,
                  }"
                  required
                />
                <label for="Street">
                  <span>{{ 'cart.street' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.valid.street' | translate }}</div>
              </div>
              <!--City-->
              <div class="form-group form-floating">
                <input
                  id="Town"
                  class="form-control"
                  name="Town"
                  type="text"
                  formControlName="Town"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Town.errors,
                  }"
                  required
                />
                <label for="Town">
                  <span>{{ 'cart.city' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.valid.city' | translate }}</div>
              </div>
              <!--Country and region-->
              <fgbcl-country-and-regions
                [SeparateRow]="true"
                [Form]="memberAddressForm"
                [HasSubmitted]="hasSubmittedMemberAddress"
              ></fgbcl-country-and-regions>
              <!--Zip code-->
              <div class="form-group form-floating">
                <input
                  id="Postcode"
                  class="form-control"
                  name="Postcode"
                  type="text"
                  formControlName="PostCode"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.PostCode.errors,
                  }"
                  required
                />
                <label for="Postcode">
                  <span>{{ 'cart.zip.code' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.valid.zip.code' | translate }}</div>
              </div>
            </form>

            <div class="edit-action-container d-flex justify-content-center align-items-center font-size-14">
              <button class="btn text-error fw-bold btn-cancel font-size-14" (click)="cancelAndRebuildForm()">Cancel</button>
              <button class="btn btn-primary text-white fw-bold btn-save font-size-14" (click)="saveMemberDetailAddress()">
                Save
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO edit member details address-->
      <!--summary of items in basket-->
      <ng-container>
        <div class="container address-container summary-container">
          <p class="fw-bold font-size-14 text-capitalize mb-3">{{ 'cart.summary' | translate }}</p>
          <div class="d-flex flex-row align-items-center justify-content-between">
            <span class="font-size-14">{{ 'cart.summary.items' | translate }}</span>
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="font-size-14 text-end">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="font-size-14 text-end">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
          <hr class="w-100" />
          <div class="d-flex flex-row justify-content-between align-items-center">
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalMerchant' | translate }}</div>
              <div class="d-flex align-items-center">
                <div class="fw-bold font-size-14 text-end">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalPoint' | translate }}</div>
              <div class="fw-bold font-size-14 text-end">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="payment-type-container" *ngIf="items$ | async as items">
        <p class="fw-bold font-size-14 text-capitalize mb-3">{{ 'cart.payment' | translate }}</p>
        <ng-container *ngIf="cardInfor.CardNumber; else noCard">
          <div class="card-infor">
            <p class="font-size-14 mb-2">
              {{ 'cart.card_infor' | translate }}
              <span class="card-number">({{ cardInfor.CardNumber | creditCardNumber: true }})</span>
            </p>
            <img alt="imagedetails" class="card-type-image" src="{{ cardInfor.CardType | cardTypeImageUrl }}" /><span
              class="font-size-14 text-info"
              >Exp:{{ cardInfor.ExpiryDate | date: 'dd/MM' }}</span
            >
          </div>
          <div class="px-0 mt-2">
            <button
              class="btn btn-primary fw-bold w-100 paynow-btn d-flex justify-content-center"
              (click)="payNow()"
              [disabled]="
                !memberAddressForm?.valid || !validCheckout || totalPoints > currentBalance || !cardInfor.CardNumber || loading
              "
            >
              {{ statusText }}
              <div *ngIf="loading" class="ms-2">
                <fgbcl-loading></fgbcl-loading>
              </div>
            </button>
            <div class="separator">
              <span class="mx-2 seperator-text">{{ 'cart.seperator' | translate }}</span>
            </div>
            <button
              (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
              [disabled]="loading || !memberAddressForm?.valid"
              class="btn btn-default fw-bold w-100 addcard-btn"
            >
              {{ 'cart.add_new_payment_method' | translate }}
            </button>
          </div>
          <div class="checkbox-container d-flex justify-content-left align-items-center">
            <input id="check-box" class="form-check-input" type="checkbox" [(ngModel)]="saveAsCardToken" [disabled]="loading" />
            <label for="check-box" class="description fw-normal">{{ 'cart.save_payment_card' | translate }}</label>
          </div>
        </ng-container>
        <ng-template #noCard>
          <button
            class="btn btn-default fw-bold mt-2 w-100 addcard-btn"
            (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
            [disabled]="!memberAddressForm?.valid"
          >
            {{ 'cart.add_new_card' | translate }}
          </button>
          <div class="checkbox-container d-flex justify-content-left align-items-center">
            <input id="check-box" class="form-check-input" type="checkbox" [(ngModel)]="saveAsCardToken" />
            <label for="check-box" class="description fw-normal">{{ 'cart.save_payment_card' | translate }}</label>
          </div>
        </ng-template>
      </div>
      <fgbcl-errors></fgbcl-errors>
    </div>
  </div>
</div>
